const { hostname, protocol, port } = window.location;

export interface Config {
  ENV: string;
  API_URL: string;
  BUILD_TARGET_ENV: string;
  NEXT_RELEASE_VERSION: string;
  API_SUFFIX: string;
  TEMP_DIRECTLINE_SECRET: string;
  IS_CI: boolean;
  ENABLE_LOCAL_RUM: boolean;
  DEV_ASSISTANT_SECRET: string;
  DEV_DISABLE_REACT_TOOLS: boolean;
  IS_SERVED_FROM_MOCK_SERVER: boolean;
  IP_GEOLOCATION_API_KEY: string;
  IS_LOCAL_DEV: boolean;
}

// Controlled by Webpack and Jest. Can be either of the following:
// 'development' - when running webpack dev server
// 'test' - when running jest
// 'production' - when building for production with webpack
const env = process.env.NODE_ENV;
const apiSuffix = '/api/v1/';
const isLocalDev = process.env.IS_LOCAL_DEV === 'true';
// API key for timezone api used in LocationForm
const ipGeoLocationApiKey = process.env.IP_GEOLOCATION_API_KEY;
const api = `${protocol}//${hostname}${port ? `:${port}` : ''}${apiSuffix}`;
// To be Deprecated
const directLineSecret = process.env.TEMP_DIRECTLINE_SECRET;
const isCI = process.env.IS_CI === 'true';
const enableLocalRum = process.env.ENABLE_LOCAL_RUM === 'true';
// For running the assistant locally
// For local development only
const devAssistantSecret = process.env.DEV_ASSISTANT_SECRET;
// For disabling the react query tools if needed as I just keep moving it
const devDisableReactTools = process.env.DEV_DISABLE_REACT_TOOLS === 'true';
// For data dog rum
const buildTargetEnv = process.env.BUILD_TARGET_ENV;
const nextReleaseVersion = process.env.NEXT_RELEASE_VERSION;

export const config: Config = {
  ENV: env,
  IS_LOCAL_DEV: isLocalDev,
  API_URL: api,
  BUILD_TARGET_ENV: buildTargetEnv,
  NEXT_RELEASE_VERSION: nextReleaseVersion,
  ENABLE_LOCAL_RUM: enableLocalRum,
  API_SUFFIX: apiSuffix,
  TEMP_DIRECTLINE_SECRET: directLineSecret,
  IS_CI: isCI,
  DEV_ASSISTANT_SECRET: devAssistantSecret,
  DEV_DISABLE_REACT_TOOLS: devDisableReactTools,
  IS_SERVED_FROM_MOCK_SERVER: hostname?.toLowerCase() === 'localhost' && port === '3333' ? true : false,
  IP_GEOLOCATION_API_KEY: ipGeoLocationApiKey,
};
